import type { RouteLocationRaw } from 'vue-router';
import type { AwCookiesPluginProvides } from '~~/common/plugins/aw-cookies';
import { uuid4 } from '~~/common/utils';
import { asObjectCookie } from '~~/common/utils/cookie';
import { getLocaleCodeForUrl } from '~~/common/utils/localeCode';

type AwCookies = AwCookiesPluginProvides['cookies'];
// Accepts both Nuxt's `navigateTo` and Vue Router's `push` — the only usage
// here passes a single `{ path, query }` location.
type NavigateFn = (to: RouteLocationRaw) => unknown;
type I18n = NonNullable<Parameters<typeof getLocaleCodeForUrl>[0]>['$i18n'];

export const COOKIE_TOKEN_EXPIRED = 'tokenExpiryLogout';

export function handleRedirectAfterTokenExpired ($i18n: I18n, $cookies: AwCookies, navigateTo: NavigateFn) {
  const locale = getLocaleCodeForUrl({ $i18n });
  $cookies.set(COOKIE_TOKEN_EXPIRED, true, {
    path: '/',
    maxAge: 30,
    sameSite: true, // strict
  });
  // NOTE: t query param is added to force the redirect by changing the url
  navigateTo({ path: `/${locale}`, query: { t: uuid4() } });
}

const awRedirectMsgKey = 'awRedirectMsg';
export const MSG_CATALOG_NOT_FOUND = 'MSG_CATALOG_NOT_FOUND';
export const MSG_SHORTLIST_NOT_FOUND = 'MSG_SHORTLIST_NOT_FOUND';
export const MSG_PRODUCT_REDIRECT = 'MSG_PRODUCT_REDIRECT';

export interface RedirectMsgEntry {
  requestId?: string;
}

export type RedirectMsg = Record<string, RedirectMsgEntry | undefined>;

interface SetCookieMsgArgs {
  nuxtApp: { $cookies: AwCookies };
  cb: (redirectMsg: RedirectMsg) => void;
}

export function setCookieMsg ({ nuxtApp, cb }: SetCookieMsgArgs) {
  const { $cookies } = nuxtApp;
  const redirectMsg: RedirectMsg = asObjectCookie<RedirectMsg>($cookies.get(awRedirectMsgKey)) ?? {};
  cb(redirectMsg);
  if (Object.keys(redirectMsg).length > 0) {
    $cookies.set(awRedirectMsgKey, redirectMsg, {
      path: '/',
      maxAge: 30,
      sameSite: true, // strict
    });
  } else {
    $cookies.remove(awRedirectMsgKey);
  }
}
